import axios from "axios";
import tracePaymentTypes from "../actions/types/tracePayment.action.type";
import store from "../store/index";
import { getExceptionMessage, API_BASE_URL } from "../utils/helper";
import axiosRetry from 'axios-retry';
import { FI } from "../constants/sharedConstants.js";

export const tracePaymentService = {
  getTracePayments,
  initiateTrace,
};

function getTracePayments(transactionData, props) {
  return (dispatch) => {
    const user = store.getState()?.loginUserReducer.user;
    const fiDetail = store.getState()?.fiReducer;
    const token = store.getState()?.loginUserReducer.token;
    axiosRetry(axios, {
      retries: 5,
      retryDelay: (retryCount) => {
        if (retryCount < 5) {
          if (props?.setErrorMessage && props?.t) {
            props?.setErrorMessage(
              props?.t("erps.transactionEnquiry.page.pending")
            );
          }
        }

        return retryCount * (retryCount < 2 ? 20000 : 30000); // time interval between retries
      },
      retryCondition: (error) => {
        return error.response.status === 504;
      },
      onRetry: (retryCount, error, requestConfig) => {
        const requestId = error?.response?.data?.message?.split("::")[0]?.trim();
        requestConfig.data = requestConfig.data?.replace('"requestId":null', `"requestId":"${requestId}"`);
      }
    });

    const request = {
          fiCompanyNumber: transactionData?.subscribeEntityId || user.fiCompanyNumber,
          userId: user.userId,
          languageCode: user.languageCode,
          fiNumber: props?.fiNumberValue,
          selectedFiNumber: fiDetail?.selectedFi,
          roleType: user?.role?.role_type,
          requestId: null,
          requestFrom: "tracePayment",
          ...transactionData
        };
    if (user.fiNumber == FI.CTB_BILLER && user.billerCrossReferenceDto)
      request.ctbId = user.billerCrossReferenceDto.centralizedBillerId;
    axios
      .post(
        `${API_BASE_URL()}/searchTracePayments`,
        request,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        if (props?.setLoading) {
          props?.setLoading(false);
        }
        if (props?.setErrorMessage) {
          props?.setErrorMessage(null);
        }
        if (props?.setBtnLoading) {
          props?.setBtnLoading(false);
        }
        const response = {
          data: res.data,
          tracePaymentDetails: { ...transactionData },
        };
        dispatch(success(response));
      })
      .catch((error) => {
        if (props?.setLoading) {
          props?.setLoading(false);
        }
        if (props?.setBtnLoading) {
          props?.setBtnLoading(false);
        }
        let errorMessage = getExceptionMessage(error);
        if (props?.setErrorMessage) {
          props?.setErrorMessage(errorMessage);
        }
        dispatch(failure(errorMessage));
      });

    function success(data) {
      return {
        type: tracePaymentTypes.GET_TRACE_SUCCESS,
        data,
      };
    }

    function failure(error) {
      return {
        type: tracePaymentTypes.GET_TRACE_ERROR,
        error,
      };
    }
  };
}
function initiateTrace(data, props) {
  return (dispatch) => {
    const user = store.getState()?.loginUserReducer.user;
    const selectedFiNumber = user.fi?.fi_number;
    const token = store.getState()?.loginUserReducer.token;
    axios
      .post(
        `${API_BASE_URL()}/initiateTrace`,
        { ...data, language_code: user.languageCode, updated_by: user.userId,
          roleType: user?.role?.role_type,
          selectedFiNumber},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      ).then((res) => {
        if (props?.setLoading) {
          props?.setLoading(false);
        }
        if (props?.setShowSuccessMessage) {
          props?.setShowSuccessMessage(true);
        }
        dispatch(success(res.data));
      }).catch((error) => {
        if (props?.setLoading) {
          props?.setLoading(false);
        }
        if (props?.setShowSuccessMessage) {
          props?.setShowSuccessMessage(false);
        }
        let errorMessage = getExceptionMessage(error);
        dispatch(failure(errorMessage));
      });

    function success(data) {
      return {
        type: tracePaymentTypes.INITIATE_TRACE_SUCCESS,
        data,
      };
    }

    function failure(error) {
      return {
        type: tracePaymentTypes.INITIATE_TRACE_ERROR,
        error,
      };
    }
  };
}